import React from "react"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import { ImageWrapper } from "@/components/common/StructuredText/components/Block"
import TextWrapper from "@/components/common/StructuredText/common/TextWrapper"
import Container from "@/components/common/Container"
import { getAspectRatioFromImage, getMarginsData } from "@/utils/utils"
import { colors } from "@/styles/themeSettings"
import styled from "styled-components"
import { formatImageCMSData } from "@/components/common/Image"
import DynamicMargin from "@/components/common/DynamicMargin"
import Image from "@/components/common/Image"

// const Image = dynamic(() => import("@/components/common/Image"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 32,
		TABLET: 64,
		DESKTOP: 64,
	},
	BOTTOM: {
		MOBILE: 32,
		TABLET: 64,
		DESKTOP: 64,
	},
}

const Wrapper = styled.div``

export default function LargeImage({ data }) {
	const author = data?.image?.customData?.author || null
	const aspectRatio = getAspectRatioFromImage(data?.image)
	const imageData = formatImageCMSData(data?.image)
	const showMetaData = data?.showMetaData || false
	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<Wrapper>
				<ImageWrapper $aspectRatio={aspectRatio} className={`large-image-container no-select ${author ? "variant-author" : ""}`}>
					<Image
						src={imageData.url}
						alt={imageData.alt}
						showMetaData={showMetaData}
						metaData={imageData.metaData}
						metaDataColor={colors.richBlack}
						sizes="100%"
					/>
				</ImageWrapper>
				<Container>
					{author && <TextWrapper className={`typo-strawford typo-strawford-82 align-end italic`}>{author}</TextWrapper>}
				</Container>
			</Wrapper>
		</DynamicMargin>
	)
}